export const elementMutatorFactory = (modifyElement) => (el) => {
    modifyElement(el);
};
//# sourceMappingURL=element-mutator.js.map